/* eslint-disable max-len, no-multiple-empty-lines, no-tabs */
// These committed HTML fragments are generated from the trusted DOCX files in /legaldocs.
const WORD_DOCUMENT_CONTENT = Object.freeze({
  'cancellation-and-refund': `
<p>
<b>DİKO
ABONELİK İPTALİ, FESİH VE İADE KOŞULLARI SÖZLEŞMESİ</b></p>
<p><b>MADDE
1 – TARAFLAR</b></p>
<p><b>1.1.
Hizmet Sağlayıcı : </b>İşbu
Sözleşmenin bir tarafı, www.dikoturkiye.com alan adlı internet
sitesi ve DİKO Platformu'nun faaliyetlerini yürüten GENOVA EĞİTİM
VE BİLİŞİM HİZMETLERİ LİMİTED ŞİRKETİ (bundan sonra
&quot;GENOVA&quot; olarak anılacaktır)'dir.</p>
<p><b>GENOVA
EĞİTİM VE BİLİŞİM HİZMETLERİ LİMİTED ŞİRKETİ</b></p>
<table>
	<col/>
	<tr>
		<td><p>
			Adres:
			Ömerağa Mah. Akçacami Cad. Turhan Apartmanı No:20 İç Kapı
			No:5 İzmit/Kocaeli</p>
			<p>
			İnternet
			Sitesi: www.dikoturkiye.com</p>
			<p>
			MERSİS
			No: 0394126763200001</p>
			<p>
			Vergi
			Dairesi / No: Tepecik / 3941267632</p>
			<p>
			Ticaret
			Sicil No: 34216</p>
			<p>
			E-posta:
			bilgi@dikoturkiye.com</p>
			<p>
			Telefon:
			+90 (262) 331 00 20 – +90 (542) 502 20 70</p>
			<p>
			KEP:
			genova.egitim@hs01.kep.tr</p>

		</td>
	</tr>
</table>

<p><b>1.2.
Kullanıcı :</b>İşbu
Sözleşmenin diğer tarafı; DİKO Platformuna üye olan, üyelik
işlemini tamamlayan ve elektronik ortamda işbu Sözleşmeyi ve
ayrılmaz parçası niteliğindeki DİKO Üyelik Sözleşmesini
onaylayan gerçek veya tüzel kişidir (bundan sonra &quot;Kullanıcı&quot;
veya &quot;Abone&quot; olarak anılacaktır).</p>

<p><b>MADDE
2 – SÖZLEŞMENİN KONUSU VE KAPSAMI</b></p>
<p>2.1.	İşbu
Sözleşmenin konusu; GENOVA tarafından DİKO Platformu üzerinden
sunulan otomatik yenilenen dijital abonelik hizmetlerine ilişkin
iptal, fesih, ödeme, iade, tarafların hak ve yükümlülükleri ile
bu kapsamda uygulanacak usul ve esasların düzenlenmesidir.</p>
<p>2.2.	DİKO
aboneliği, satın alma ekranında aksi açıkça belirtilmedikçe
aylık olarak otomatik yenilenen ve herhangi bir taahhüt içermeyen
dijital abonelik hizmetidir. Taraflar, işbu Sözleşmenin elektronik
ortamda onaylanması ile hükümlerinin kendileri bakımından
bağlayıcı olduğunu kabul, beyan ve taahhüt ederler.</p>
<p><b>MADDE
3 – ABONELİĞİN İPTAL HÜKÜMLERİ</b></p>
<p><b>3.1.Kampanyalı
Abonelikler: </b>GENOVA,
belirli tarihler, paketler, kullanıcı grupları veya kullanım
koşullarıyla sınırlı kampanyalar düzenleyebilir. Bu kapsamda
her kampanyanın;<b>
</b>a)
Başlangıç ve bitiş tarihi,<b>
</b>b)
Kampanya Döneminde uygulanacak ücret, indirim veya ücretsiz
kullanım koşulu,<b>
</b>c)
Kampanya sonrası aylık abonelik bedeli,<b>
</b>ç)
İlk tahsilat tarihi, d) Otomatik yenileme koşulları, satın alma
işlemi tamamlanmadan önce ödeme ekranında açıkça
gösterilecektir. GENOVA, kampanyaları yeni abonelikler bakımından
değiştirebilir veya sona erdirebilir. Kampanya koşullarına uygun
şekilde abonelik satın alan kullanıcıların kazanılmış
kampanya hakları, ilan edilen Kampanya Dönemi boyunca korunur.</p>

<p>
<b>3.2.
Otomatik Yenileme ve Tahsilat</b></p>
<p>
3.2.1.
Abonelik, kullanıcı tarafından iptal edilmediği sürece her ay
otomatik olarak yenilenecektir.</p>
<p>
3.2.2.
Kampanya Döneminin sona ermesi üzerine, ödeme ekranında
gösterilen aylık abonelik bedeli kayıtlı ödeme yönteminden
tahsil edilecektir. Sonraki tahsilatlar, abonelik iptal edilene kadar
aylık olarak devam edecektir.</p>
<p>
3.2.3.Kart
ve ödeme bilgileri iyzico altyapısı üzerinden
işlenecektir.GENOVA, kartının tam numarasını ve kart güvenlik
kodunu kendi sistemlerinde saklamaz.</p>
<p>
<b>3.3.
Abonelik İptal işlemleri</b></p>
<p>
3.3.1.	Abone,
aboneliğini dilediği zaman herhangi bir gerekçe göstermeden ve
cezai şart ödemeden iptal edebilir.</p>
<p>
3.3.2.
İptal işlemi; DİKO hesap veya abonelik ayarları üzerinden ya da
DİKO tarafından sunulan diğer elektronik iptal kanalları
kullanılarak gerçekleştirilebilir.</p>
<p>
3.3.3.
İptal talebinin alınmasının ardından kullanıcıya elektronik
teyit gönderilecektir.</p>
<p>
<b>3.4.
Kampanya Döneminde İptal</b></p>
<p>
3.4.1.
Abonelik, ilk ücretli tahsilat tarihinden önce iptal edilirse
herhangi bir abonelik bedeli tahsil edilmeyecek olup  İptal
talebinin, ödeme ekranında belirtilen ilk tahsilat tarihinden önce
tamamlanması gerekmektedir.</p>
<p>
3.4.2.
Kampanya Döneminde yapılan iptal, kullanıcının kampanya
kapsamındaki hizmet erişimini iptal tarihinden hemen sonra veya
kampanya döneminin sonunda sona erdirebilir. Uygulanacak erişim
süresi, ilgili kampanya koşullarında gösterilecektir.</p>
<p>
<b>3.5.
Ücretli Dönemde İptal</b></p>
<p>
3.5.1.
Ücretli Abonelik Dönemi başladıktan sonra yapılan iptal, sonraki
yenilemeleri durduracaktır.</p>
<p>
3.5.2.Kullanıcı,
ödemesini yaptığı mevcut aylık dönemin sonuna kadar hizmetten
yararlanmaya devam edebilir.</p>
<p>
3.5.3.İptal
işleminden sonra yeni dönem için ücret tahsil edilmez. Mevcut
ücretli dönemin kullanılmayan günleri için, emredici mevzuat
veya aşağıda belirtilen iade durumları dışında, oransal iade
yapılmaz.</p>

<table>
	<col/>
	<col/>
	<tr>
		<td><p>
			<b>İADE
			YAPILABİLECEK DURUMLAR</b></p>

		</td>
		<td><p>
			<b>İADE
			YAPILMAYAN DURUMLAR</b></p>

		</td>
	</tr>
	<tr>
		<td><p>
			Aşağıdaki
			durumlarda tam veya kısmi ödeme iadesi yapılabilir:</p>
			<p>
			a)
			Aynı dönem için birden fazla tahsilat yapılması,</p>
			<p>
			b)
			Ödeme ekranında gösterilenden farklı tutar tahsil edilmesi,</p>
			<p>
			c)
			Abonelik iptal edildiği hâlde sonraki dönem için ücret
			alınması,</p>
			<p>
			ç)
			Tahsilatın yetkisiz veya hatalı olduğunun doğrulanması,</p>
			<p>
			d)
			GENOVA’dan kaynaklanan teknik nedenle hizmetin uzun süre veya
			esaslı biçimde sunulamaması,</p>
			<p>
			e)
			GENOVA tarafından hizmetin sona erdirilmesi nedeniyle ödenmiş
			dönemin kullanılamaması,</p>
			<p>
			f)
			İadenin yürürlükteki mevzuat gereği zorunlu olması,</p>
			<p>
			g)
			GENOVA tarafından talebin haklı bulunması.</p>

		</td>
		<td><p>
			Aşağıdaki
			durumlar tek başına ödeme iadesi hakkı doğurmaz:</p>
			<p>
			a)
			Abonenin hizmeti kullanmaması veya hesabına giriş yapmaması,</p>
			<p>
			b)
			Abonenin cihazı, internet bağlantısı, tarayıcısı veya kendi
			teknik altyapısından kaynaklanan sorunlar,</p>
			<p>
			c)
			Kullanıcının hesap bilgilerini yanlış girmesi veya güncel
			tutmaması,</p>
			<p>
			ç)
			Aboneliğin ücretli dönem başladıktan sonra iptal edilmesi,</p>
			<p>
			d)
			Platformun sözleşmeye aykırı kullanılması nedeniyle hesabın
			askıya alınması,</p>
			<p>
			e)
			Geçici ve makul süreli bakım, güncelleme veya güvenlik
			kesintileri.</p>
			<p>
			Emredici
			mevzuat hükümleri ile ayıplı veya hiç sunulmayan hizmetlere
			ilişkin haklar saklıdır.</p>

		</td>
	</tr>
</table>

<p>
<b>4.İADE
TALEBİ ve ŞEKLİ</b></p>
<p>
4.1.	Abonelerin
iade talepleri  <a href="mailto:destek@genovahq.com"><u>destek@genovahq.com</u></a>
adresine gönderilebilir. Gönderilen iade talebinde bulunması
zorunlu bilgiler; a) Abonelik hesabına kayıtlı ad ve soyad veya
ticaret unvanı, b) Kayıtlı e-posta adresi, c) Ödeme tarihi, ç)
Ödeme tutarı, d) İşlem veya fatura numarası, e) İade gerekçesi,
f) Varsa talebi destekleyen belge veya ekran görüntüsü.</p>
<p>
4.2.	Hizmet
sağlayıcı tarafından iade talebi makul süre içinde incelenir ve
sonuç kullanıcıya elektronik ortamda bildirilir. Onaylanan
iadeler, ödemenin gerçekleştirildiği karta ve iyzico ödeme
altyapısı üzerinden yapılır. Güvenlik ve ödeme mevzuatı
nedeniyle iade, farklı bir karta, farklı bir kişi adına veya
başka bir banka hesabına gönderilmeyecektir. GENOVA'nın iade
işlemini başlatmasından sonra ödemenin Kullanıcının hesabına
veya kartına yansıma süresi, ödeme kuruluşu ve ilgili bankanın
işlem süreçlerine bağlı olup, bu sürelerden GENOVA sorumlu
değildir.</p>
<p><b>MADDE
5: FİYAT DEĞİŞİKLİĞİ </b>
</p>
<p>
Abonelik ücretinde değişiklik yapılması hâlinde yeni ücret,
uygulanacağı yenileme döneminden önce Aboneye bildirilir. Yeni
fiyat geçmiş dönemlere uygulanmaz. Abone yeni fiyatı kabul
etmiyorsa fiyat değişikliğinin uygulanacağı tarihten önce
aboneliğinin iptalini talep edebilir.</p>
<p><b>MADDE
6 – UYGULANACAK SÖZLEŞME HÜKÜMLERİ</b></p>
<p>6.1.
İşbu DİKO Abonelik İptali, Fesih ve İade Koşulları Sözleşmesi,
DİKO Üyelik Sözleşmesinin ayrılmaz bir eki ve tamamlayıcı
parçası niteliğindedir. İşbu Sözleşmede hüküm bulunmayan
hâllerde DİKO Üyelik Sözleşmesi hükümleri uygulanır.</p>
<p>6.2.
İşbu Sözleşmenin uygulanmasından veya yorumlanmasından
doğabilecek her türlü uyuşmazlık bakımından DİKO Üyelik
Sözleşmesinde yer alan yetkili mahkeme, icra daireleri, uygulanacak
hukuk ve diğer usul hükümleri aynen geçerlidir. Taraflar
arasındaki hukuki ilişkinin değerlendirilmesinde işbu Sözleşme
ile DİKO Üyelik Sözleşmesi birlikte uygulanır ve birlikte
yorumlanır.</p>
<p><b>MADDE
7 – DEĞİŞİKLİK</b></p>
<p>GENOVA,
yürürlükteki mevzuata aykırı olmamak kaydıyla işbu Sözleşmede
değişiklik yapma hakkını saklı tutar. Yapılan değişiklikler,
internet sitesinde yayımlandığı veya elektronik ortamda
Kullanıcıya bildirildiği tarihte yürürlüğe girer.
Değişikliklerin yürürlüğe girmesinden sonra aboneliğin devam
ettirilmesi, Kullanıcının değişiklikleri kabul ettiği anlamına
gelir. Emredici mevzuattan doğan haklar saklıdır.</p>
<p><b>MADDE
8– YÜRÜRLÜK</b></p>
<p>İşbu
Sözleşme, Kullanıcının elektronik ortamda &quot;okudum, anladım
ve kabul ediyorum&quot; beyanıyla onay vermesi üzerine yürürlüğe
girer. Kullanıcı, işbu Sözleşmeyi dikkatle okuduğunu,
hükümlerini anladığını ve özgür iradesi ile kabul ettiğini
beyan eder.</p>
`,
  'cookie-notice': `
<h1>
ÇEREZLERE
DAİR
AYDINLATMA
METNİ</h1>

<p>Bu
metin, 6698 sayılı Kişisel Verilerin Korunması Kanunu’nun
(Kanun) 10’uncu maddesi ile Aydınlatma Yükümlülüğünün
Yerine Getirilmesinde Uyulacak Usul ve Esaslar Hakkında Tebliğ
kapsamında veri sorumlusu sıfatıyla hazırlanmıştır.</p>

<p>Bu
Çerez Aydınlatma Metni’nin amacı, internet sitemizde kullanılan
çerezlerin cihazınıza yerleştirilmesi aracılığıyla otomatik
yolla elde edilen kişisel verilerin işlenmesine ilişkin olarak,
hangi amaçlarla
hangi tür
çerezleri kullandığımız,
hukuki sebebi
ve haklarınız
hakkında sizlere
bilgi vermektir.</p>

<p>İnternet
sitemizde yalnızca
hizmetin sağlanması
için kesinlikle
gerekli olarak
birinci taraf
oturum ve kalıcı
çerezler kullanılmaktadır.</p>

<h2>Çerez
Çeşitleri</h2>

<p>
<b>Kullanım süresine göre çerez çeşitleri: </b>Oturum çerezi,
oturumun sürekliliğinin sağlanması amacıyla kullanılmakta olup
kullanıcı tarayıcısını kapattığında bu çerezler de
silinmektedir. Kalıcı çerez ise internet tarayıcısı kapatıldığı
zaman silinmemekte ve belirli bir tarihte veya belirli bir süre
sonra kendiliğinden
silinmektedir. Bu
çerçevede, internet
sitemizde kullanım
sürelerine göre
oturum ve kalıcı çerezler kullanılmaktadır.</p>

<p><b>Birinci
taraf ve üçüncü taraf çerezler: </b>Birinci taraf çerezler,
doğrudan kullanıcının ziyaret ettiği internet sitesi yani
tarayıcının adres çubuğunda gösterilen adres tarafından
yerleştirilmektedir. Üçüncü taraf çerezlerse, kullanıcının
ziyaret ettiği adres dışında farklı bir etki alanı tarafından
yerleştirilmektedir. Bu çerçevede, internet sitemizde yalnızca
birinci tarat çerez kullanılmaktadır.</p>

<h2>Kullanım
amaçlarına göre çerez çeşitleri: Çerezler kullanım amaçlarına
göre kesinlikle gerekli, işlevsel veya reklam/pazarlama gibi
amaçlarla kullanılabilmektedir. Bu çerçevede, internet sitemizde
açıkça talep etmiş olduğunuz bilgi
toplum hizmetlerinin sunulabilmesi için kesinlikle gerekli
çerezler kullanılmaktadır. Bu kapsamda,</h2>

<ol type="A">
	<li><p>İnternet
	sayfasında internet sayfasına, sonradan gelen isteklerin güvenilir
	olup olmadığını anlamak amacıyla <i>cookiesession1
	</i>isimli birinci
	taraf kalıcı çerezini (bir yıl saklanmaktadır),</p></li>
	<li><p>Oturum
	yönetimi amacıyla kullanılan <i>PHPSESSID
	</i>çerezini
	(Yalnızca oturum süresince geçerli olup tarayıcı kapatıldığında
	otomatik olarak silinmektedir),</p></li>
	<li><p>Çerez
	aydınlatma metninin okunduğunun teyidi amacıyla
	<i>cookiepolicy_status
	</i>isimli birinci
	taraf kalıcı çerezini (bir yıl saklanmaktadır.)</p></li>
	<li><p>Kullanıcının
	websitesinde ziyaret ettiği bir önceki sayfasının adres
	bilgisini (referans) tutan <i>http_referer</i><i>
	</i>çerezini
	(Yalnızca oturum süresince geçerli olup tarayıcı kapatıldığında
	otomatik olarak silinmektedir.)</p></li>
</ol>
<p>IP bilgilerinizle
ilişkilendirmek suretiyle kişisel verileriniz işlenmektedir. Söz
konusu kişisel verileriniz başka veri sorumlularına
aktarılmamaktadır.</p>
`,
  'kvkk-notice': `
<p>
<b>AYDINLATMA METNİ</b></p>
<p>
Genova Eğitim ve Bilişim
Hizmetleri Ltd. Şti.  (“İşyeri”) olarak, 6698 Sayılı Kişisel
Verilerin Korunması Kanunu’nun (“Kanun”) 10’uncu maddesi
uyarınca hazırladığımız ve tüm veri kategorileri ile kişi
gruplarına ait olmak üzere kişisel veri işleme faaliyeti hakkında
bilgi içeren aydınlatma metnini kamuoyunun ve ilgili kişilerin
bilgilerine sunarız;</p>
<p>
<b>MADDE 1: VERİ SORUMLUSU</b></p>
<p>
Kişisel verileriniz, veri
sorumlusu sıfatıyla Genova Eğitim ve Bilişim Hizmetleri Ltd. Şti.
tarafından aşağıda açıklanan kapsamda işlenebilecektir. Veri
sorumlusu kavramından anlaşılması gereken; kişisel verilerin
işleme amaçlarını ve vasıtalarını belirleyen, veri kayıt
sisteminin kurulmasında ve yönetilmesinden sorumlu gerçek veya
tüzel kişidir.</p>
<p>
Veri sorumlusuyla irtibata
geçmek için aşağıdaki kanalları kullanabilirsiniz:</p>
<p>
Adres	: Ömerağa Mh. Akça
Cami Cd. No: 20 Türhan Apt. Kat: 1/5 İzmit-KOCALİ</p>
<p>
Telefon : 0262 331 00 20</p>
<p>
<b>MADDE 2: İŞLENEN KİŞİSEL
VERİLER ve KİŞİSEL VERİLERİN İŞLEME AMACI</b></p>
<p>
Çalışan, çalışan adayı,
potansiyel ürün veya hizmet alıcısı, ürün veya hizmet alıcısı
(bundan böyle “hasta” olarak anılacaktır), tedarikçi
çalışanı, tedarikçi yetkilisi, veli/vasi/temsilci ve
ziyaretçilere ait bulunup tarafımızca işlenen kişisel veri
kategorileri aşağıda sıralanmış olup her bir veri kategorisi,
karşısında belirtilen amaçlarla işlenmektedir:</p>
<ul>
	<li><p>Ceza
	mahkûmiyeti ve güvenlik tedbirleri / Çalışanlar için iş akdi
	ve mevzuattan kaynaklı yükümlülüklerin yerine getirilmesi</p></li>
	<li><p>Felsefi
	inanç, din, mezhep ve diğer inançlar / Çalışanlar için iş
	akdi ve mevzuattan kaynaklı yükümlülüklerin yerine getirilmesi</p></li>
	<li><p>İletişim
	/ Çalışanlar için iş akdi ve mevzuattan kaynaklı
	yükümlülüklerin yerine getirilmesi, eğitim faaliyetlerinin
	yürütülmesi, insan kaynakları süreçlerinin planlanması,
	yetkili kişi, kurum ve kuruluşlara bilgi verilmesi, yönetim
	faaliyetlerinin yürütülmesi, mal hizmet satın alım süreçlerinin
	yönetilmesi, hukuk işlerinin takibi ve yürütülmesi,
	faaliyetlerin mevzuata uygun yürütülmesi, Ürün / hizmetlerin
	pazarlama süreçlerinin yürütülmesi, Mal ve hizmet satış
	sonrası destek hizmetlerinin yürütülmesi</p></li>
	<li><p>Kimlik
	/ Çalışanlar için iş akdi ve mevzuattan kaynaklı
	yükümlülüklerin yerine getirilmesi, eğitim faaliyetlerinin
	yürütülmesi, insan kaynakları süreçlerinin planlanması,
	saklama ve arşiv faaliyetlerinin yürütülmesi, yetkili kişi
	kurum ve kuruluşlara bilgi verilmesi, yönetim faaliyetlerinin
	yürütülmesi çalışanlar için yan haklar ve menfaatleri
	süreçlerinin yürütülmesi, mal hizmet satın alım süreçlerinin
	yönetilmesi, hukuk işlerinin takibi, faaliyetlerin mevzuata uygun
	yürütülmesi, ürün / hizmetlerin pazarlama süreçlerinin
	yürütülmesi, hizmetin ifası</p></li>
	<li><p>Mesleki
	deneyim / Çalışanlar için iş akdi ve mevzuattan kaynaklı
	yükümlülüklerin yerine getirilmesi, çalışanlar için yan
	haklar ve menfaatleri süreçlerinin yürütülmesi, ürün
	hizmetlerin pazarlama süreçlerinin yürütülmesi</p></li>
	<li><p>Finans
	/ Çalışanlar için iş akdi ve mevzuattan kaynaklı
	yükümlülüklerin yerine getirilmesi, çalışanlar için yan
	haklar ve menfaatleri süreçlerinin yürütülmesi, finans ve
	muhasebe işlerinin yürütülmesi, finans ve muhasebe işlerinin
	yürütülmesi</p></li>
	<li><p>Sağlık
	bilgileri / Çalışanlar için iş akdi ve mevzuattan kaynaklı
	yükümlülüklerin yerine getirilmesi, iş sağlığı güvenliği
	faaliyetlerinin yürütülmesi, faaliyetlerin mevzuata uygun
	yürütülmesi, yetkili kişi kurum ve kuruluşlara bilgi verilmesi,
	hizmetin ifası</p></li>
	<li><p>Özlük
	/ Çalışanlar için iş akdi ve mevzuattan kaynaklı
	yükümlülüklerin yerine getirilmesi</p></li>
	<li><p>Fiziksel
	mekân güvenliği / Fiziksel mekân güvenliğinin temini</p></li>
	<li><p>Cinsel
	hayat / Faaliyetlerin mevzuata uygun yürütülmesi, hizmetin ifası</p></li>
</ul>

<p>
<b>MADDE 3: KİŞİSEL
VERİLERİN AKTARILABİLECEĞİ TARAFLAR VE AKTARMA AMACI</b></p>
<p>
Bu aydınlatma metnine konu
kişisel verilerden, yasal yükümlülüklerin yerine getirilmesi ve
iş akdi ile mevzuattan kaynaklı yükümlülüklerin
gerçekleştirilmesi amacıyla aktarılanlar ve bunların aktarıldığı
yerler aşağıda sıralanmıştır:</p>
<ul>
	<li><p>Kimlik
	/ Sosyal Güvenlik Kurumu, mali müşavir, tedarikçiler</p></li>
	<li><p>Mesleki
	deneyim / Sosyal Güvenlik Kurumu, mali müşavir</p></li>
	<li><p>Finans
	/ Sosyal Güvenlik Kurumu, mali müşavir</p></li>
	<li><p>Mesleki
	deneyim / Sosyal Güvenlik Kurumu, mali müşavir</p></li>
	<li><p>Sağlık
	bilgileri / Sosyal Güvenlik Kurumu, Ortak Sağlık Güvenlik
	Birimi, tedarikçiler, özel sigorta şirketleri</p></li>
	<li><p>Fiziksel
	mekân güvenliği / Yetkili kamu kurum ve kuruluşları</p></li>
	<li><p>Özlük
	/ Gerçek kişiler veya özel hukuk tüzel kişileri</p></li>
</ul>

<p>
<b>MADDE 4: KİŞİSEL VERİ
TOPLAMA YÖNTEMLERİ VE HUKUKİ SEBEPLERİ</b></p>
<p>
Çalışan, çalışan adayı,
potansiyel ürün veya hizmet alıcısı, ürün veya hizmet alıcısı
(bundan böyle “hasta” olarak anılacaktır), tedarikçi
çalışanı, tedarikçi yetkilisi ve ziyaretçilere ait kişisel
veriler aşağıda belirtilen yollarla toplanmaktadır:</p>
<ul>
	<li><p>Çalışanlara
	ait kişisel veriler, ilgili kişinin fiziksel ortamda belge teslim
	etmesi yoluyla</p></li>
	<li><p>Çalışan
	adayının özgeçmişi, ilgili kişinin fiziksel ortamda
	özgeçmişini teslim etmesi veya e-posta benzeri sanal yöntemlerle
	göndermesi yoluyla</p></li>
	<li><p>Tedarikçi
	yetkilisi ve çalışanına ait kişisel veriler otomatik olmayan
	yöntemlerle</p></li>
	<li><p>Hastalara
	ait kişisel veriler, ilgili kişinin fiziksel ortamda form
	doldurması ve kişisel verilerini sözlü olarak beyan etmesi
	yoluyla</p></li>
	<li><p>Ziyaretçilere
	ve potansiyel ürün hizmet alıcılarına ait kişisel veriler
	sözlü olarak beyan edilmesi yoluyla</p></li>
</ul>
<p>
Kişisel verilerin toplanması
ve işlenmesine dair hukuki sebep; bu aydınlatma metninin 2/a, 2/b/,
2/f ve 2/h fıkraları için aşağıdadır:</p>
<ul>
	<li><p>Sözleşmenin
	taraflarına ait kişisel verilerin işlenmesinin gerekli olması</p></li>
</ul>
<p>
2/c, 2/d, 2/h fıkraları için
aşağıdadır:</p>
<ul>
	<li><p>Sözleşmenin
	taraflarına ait kişisel verilerin işlenmesinin gerekli olması,
	meşru menfaatleri için veri işlenmesinin zorunlu olması.</p></li>
</ul>
<p>
2/e fıkrası için hukuki
sebep açık rıza alınmasıdır.</p>
<p>
2/g fıkrası için ise hukuki
sebep açık rıza alınması ile tıbbi teşhis, tedavi ve bakım
hizmetlerinin yürütülmesi amacıyla işlenmesidir.</p>
<p>
2/i fıkrası için ayrıca,
herhangi bir hukuki yükümlülüğünü yerine getirmesi amacıyla
işlenmesinin gerekli olması sebebi de mevcuttur.</p>
<p>
2/j fıkrası için hukuki
sebep, tıbbi teşhis, tedavi ve bakım hizmetlerinin yürütülmesi
amacıyla işlenmesidir</p>
<p>
<b>MADDE 5: KİŞİSEL
VERİLERİN SAKLAMA SÜRESİ</b></p>
<p>
Bu aydınlatma metninde yazılı
kişisel verilerin veri kategorilerine göre saklama süreleri
aşağıda listelenmiş olup süre sonunda kişisel veriler imha
edilir.</p>
<ul>
	<li><p>Ceza
	mahkûmiyeti ve güvenlik tedbirleri / İş ilişkisinin sona
	ermesinden itibaren 1 yıl</p></li>
	<li><p>Felsefi
	inanç, din, mezhep ve diğer inançlar / İş ilişkisinin sona
	ermesinden itibaren 10 yıl</p></li>
	<li><p>İletişim
	/ İş ilişkisinin sona ermesinden itibaren 10 yıl / Hastadan
	edinilmesinden itibaren 20 yıl</p></li>
	<li><p>Kimlik
	/ İş ilişkisinin sona ermesinden itibaren 10 yıl / Hastadan
	edinilmesinden itibaren 20 yıl</p></li>
	<li><p>Mesleki
	deneyim / İş ilişkisinin sona ermesinden itibaren 10 yıl</p></li>
	<li><p>Finans
	/ İş ilişkisinin sona ermesinden itibaren 10 yıl</p></li>
	<li><p>Sağlık
	bilgileri / İş ilişkisinin sona ermesinden itibaren 10 yıl / İş
	sağlığı ve güvenliği nedeniyle işlenen verilerde iş ilişkisi
	sona erdikten sonra 15 yıl / Hastadan edinilmesinden itibaren 20
	yıl</p></li>
	<li><p>Askerlik
	durumu İş ilişkisinin sona ermesinden itibaren 10 yıl</p></li>
	<li><p>Özlük
	/ İş ilişkisinin sona ermesinden itibaren 10 yıl</p></li>
	<li><p>Fiziksel
	mekân güvenliği / 1 ay</p></li>
	<li><p>Özgeçmiş
	/ Elde edilmesinden itibaren 1 yıl</p></li>
	<li><p>Cinsel
	hayat / Elde edilmesinden itibaren 20 yıl</p></li>
</ul>

<p>
<b>MADDE 6: İLGİLİ KİŞİNİN
HAKLARI</b></p>
<p>
Kişisel verisi işlenen
gerçek kişi, ilgili kişi olarak tanımlanır ve işyerine
başvurarak kendisiyle ilgili aşağıdaki haklara sahiptir:</p>
<ul>
	<li><p>Kişisel
	veri işlenip işlenmediğini öğrenme</p></li>
	<li><p>Kişisel
	verileri işlenmişse buna ilişkin bilgi talep etme</p></li>
	<li><p>Kişisel
	verilerin işlenme amacını ve bunların amacına uygun kullanılıp
	kullanılmadığını öğrenme</p></li>
	<li><p>Yurt
	içinde veya yurt dışında kişisel verilerin aktarıldığı
	üçüncü kişileri bilme</p></li>
	<li><p>Kişisel
	verilerin eksik veya yanlış işlenmiş olması halinde bunların
	düzeltilmesini isteme</p></li>
	<li><p>Kişisel
	verilerin silinmesini veya yok edilmesini isteme</p></li>
	<li><p>(e)
	ve (f) bentleri uyarınca yapılan işlemlerin, kişisel verilerin
	aktarıldığı üçüncü kişilere bildirilmesini isteme</p></li>
	<li><p>İşlenen
	verilerin münhasıran otomatik sistemler vasıtasıyla analiz
	edilmesi suretiyle kişinin kendisi aleyhine bir sonucun ortaya
	çıkmasına itiraz etme</p></li>
	<li><p>Kişisel
	verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara
	uğraması halinde zararın giderilmesini talep etme</p></li>
</ul>
<p>
<br/>
Saygılarımızla;</p>
<p>
<b>Genova Eğitim ve Bilişim
Hiz. Ltd. Şti.</b></p>
`,
  'data-subject-application-form': `
<p>
<b>KİŞİSEL
VERİLERİN İŞLENMESİNE DAİR BAŞVURU FORMU HAKKINDA
BİLGİLENDİRME</b></p>

<p>
Kişisel
verileriniz, 6698 sayılı Kişisel Verilerin Korunması Kanunu
(“KVKK” veya “Kanun”) uyarınca, veri sorumlusu sıfatımız
ile Kişisel Verilerinin Korunması ve İşlenmesi Politikası’nda
(‘Politika’) açıklanan şartlarda toplanmakta, işlenmekte ve
aktarılmaktadır. 6698
sayılı Kişisel Verilerin Korunması  kanunu hakkında detaylı
bilgi almak için sitemizdeki kanunlar bölümünden inceleme
yapabilirsiniz.</p>

<ol>
	<li><p>
	<b>Başvuru
	Hakkınızın Dayanağı </b>
	</p></li>
</ol>

<p>
Kanun’un 11.
maddesinde<a name="sdfootnote1anc" href="#sdfootnote1sym"><sup>1</sup></a>,
veri sahiplerine (‘veri sahibi’), veri sorumlusuna başvurarak
kendisiyle ilgili aynı maddede sayılan haklara sahip olduğu
düzenlenmiştir. Kanun’da yer alan bu haklarınız Politikamız
ile Aydınlatma Metni’nde de detaylı bir şekilde belirtilmiştir.

</p>

<p>
Veri sahibi
olarak sizlerin, bu haklarınız kapsamında yapacağınız
başvurulara ilişkin usul ve esaslar ise Kanun’un 13. maddesinde<a name="sdfootnote2anc" href="#sdfootnote2sym"><sup>2</sup></a>
ve ayrıca Veri Sorumlusuna Başvuru Usul ve Esasları Hakkında
Tebliğ’de (‘Tebliğ’) düzenlenmiştir.
</p>

<p>
Kanun’un 13.
maddesinde ve Tebliğ’in 5. maddesinde düzenlenen hükümlere
göre, veri sahipleri, bu taleplerini (i) yazılı olarak, (ii)
kayıtlı elektronik posta (KEP) adresi, güvenli elektronik imza,
mobil imza ya da ilgili kişi tarafından veri sorumlusuna daha önce
bildirilen ve veri sorumlusunun sisteminde kayıtlı bulunan
elektronik posta adresini kullanmak suretiyle (iii) başvuru amacına
yönelik geliştirilmiş bir yazılım ya da uygulama vasıtasıyla
veri sorumlusuna iletebilir.
</p>

<ol start="2">
	<li><p>
	<b>Başvuruların
	Cevaplanması</b></p></li>
</ol>
<p>
Yukarıdaki
kanallar ile göndereceğiniz başvurularınız, Kanun’un 13.
maddesi ve Tebliğ’in 6. maddesine uygun olarak, talebinizin
niteliğine göre, en kısa sürece ve en geç otuz (30) gün içinde
kural olarak ücretsiz olarak, ancak istisnaen ek bir maliyet
gerektirmesi halinde Kişisel Verileri Koruma Kurulu tarafından
belirlenen tarifedeki ücret karşılığında sonuçlandırılacaktır.</p>
<p>
Talebinizin
kabul edilmesi halinde, talebinizin gereği en kısa sürede yerine
getirilecek ve tarafınıza bilgi verilecektir. Talebinizin
reddedilmesi halinde ise red gerekçesi açıklanarak tarafınıza
bilgi verilecektir.
</p>

<p>
<b>Önemle hatırlatmak isteriz
ki Kişisel Verileri Koruma Kurulu’na şikayette bulunabilmek için
öncelikle veri sorumlusuna  başvuru yolunun tüketilmesi
gerekmektedir. Veri sorumlusu uyarınca başvurunuzun reddedilmesi,
verilen cevabın yetersiz görülmesi yahut süresinde başvuruya
cevap verilmemesi halinde  Kanunun 14. Maddesi <a name="sdfootnote3anc" href="#sdfootnote3sym"><sup>3</sup></a>
 uyarınca  Kurula şikayette bulunulabilir. Şikayet üzerine
Kurulun incelemesinin usul ve esasları 15. Maddede <a name="sdfootnote4anc" href="#sdfootnote4sym"><sup>4</sup></a>
düzenlenmiştir.</b></p>

<p>
Saygılarımızla,</p>
<ul>
	<li><p>
	GENOVA
	EĞİTİM VE BİLİŞİM HİZMETLERİ LİMİTED ŞİRKETİ</p></li>
	<li><p>
	İnternet
	Sitesi: dikoturkiye.com</p></li>
	<li><p>
	Merkez
	Adresi: Ömerağa Mahallesi Akçacami Caddesi No:20 Türhan
	Apartmanı Kat:1 İç Kapı No:5 İzmit/Kocaeli, Türkiye</p></li>
	<li><p>
	E-posta
	Adresi: bilgi@dikoturkiye.com</p></li>
	<li><p>
	Telefon:
	+90 262 331 00 20 / +90 542 502 20 70</p></li>
	<li><p>
	KEP
	Adresi: <u><a href="mailto:genova.egitim@hs01.kep.tr">genova.egitim@hs01.kep.tr</a></u></p></li>
</ul>
<p>
<b>EK: BAŞVURU
FORMU</b></p>

<ol type="A">
	<li><p><b>Başvuru
	Sahibine İlişkin Bilgiler</b></p></li>
</ol>

<table>
	<col/>
	<col/>
	<col/>
	<tr>
		<td height="11"><p>
			<b>1</b></p>
		</td>
		<td><p>
			İsim
			Soyisim</p>
		</td>
		<td>
		</td>
	</tr>
	<tr>
		<td height="12"><p>
			<b>2</b></p>
		</td>
		<td><p>
			TC
			Kimlik Numarası</p>
		</td>
		<td>
		</td>
	</tr>
	<tr>
		<td height="12"><p>
			<b>3</b></p>
		</td>
		<td><p>
			Yabancılar
			için uyruğu, pasaport numarası veya varsa kimlik numarası</p>
		</td>
		<td>
		</td>
	</tr>
	<tr>
		<td height="12"><p>
			<b>4</b></p>
		</td>
		<td><p>
			Tebligata
			esas yerleşim yeri veya iş yeri adresi</p>
		</td>
		<td>
		</td>
	</tr>
	<tr>
		<td height="12"><p>
			<b>5</b></p>
		</td>
		<td><p>
			Telefon
			Numarası</p>
		</td>
		<td>
		</td>
	</tr>
	<tr>
		<td height="11"><p>
			<b>6</b></p>
		</td>
		<td><p>
			E-mail
			Adresi</p>
		</td>
		<td>
		</td>
	</tr>
</table>

<ol type="A" start="2">
	<li><p><b>Başvuru
	Sahibinin Diko Aboneliği ile Olan İlişkisi</b></p></li>
</ol>

<table>
	<col/>
	<col/>
	<col/>
	<tr>
		<td height="11"><p>
			<b>1</b></p>
		</td>
		<td>

			<p>
			<i>(Yandakilerden
			birini seçiniz, açıklamaları yazınız. </i>
			</p>
			<p>
			<i>Farklı
			bir ilişkiniz mevcut ise belirtiniz.)</i></p>

		</td>
		<td>
			<table>
				<col/>
				<col/>
				<col/>
				<tr>
					<td>
					</td>
					<td><p>
						<b>KULLANICI
						/    ÜYE</b></p>

					</td>
					<td>
					</td>
				</tr>
				<tr>
					<td>
					</td>
					<td><p>
						Çalışan
						/  Çalışan Adayı</p>
						<p>
						<i>(başvurunuza
						ilişkin bilgileri yazınız)</i></p>
					</td>
					<td>
					</td>
				</tr>
				<tr>
					<td>
					</td>
					<td><p>
						Eski
						Çalışan</p>
						<p>
						<i>(işten
						ayrıldığınız tarihi yazınız)</i></p>
					</td>
					<td>
					</td>
				</tr>
				<tr>
					<td>
					</td>
					<td><p>
						Üçüncü
						Taraf Firma Çalışanı <i>(firmanızı
						yazınız)</i></p>
					</td>
					<td>
					</td>
				</tr>
				<tr>
					<td>
					</td>
					<td><p>
						İş
						Ortağı</p>

					</td>
					<td>
					</td>
				</tr>
				<tr>
					<td>
					</td>
					<td><p>
						Hissedar</p>

					</td>
					<td>
					</td>
				</tr>
				<tr>
					<td>
					</td>
					<td><p>
						Ziyaretçi</p>
						<p>
						<i>(ziyaret
						tarihinizi ve yerinizi yazınız)</i></p>
					</td>
					<td>
					</td>
				</tr>
				<tr>
					<td>
					</td>
					<td><p>
						Diğer</p>
						<p>
						<i>(açıklayınız)</i></p>
					</td>
					<td>
					</td>
				</tr>
			</table>

		</td>
	</tr>
	<tr>
		<td height="11"><p>
			<b>2</b></p>
		</td>
		<td><p>
			İlişkinin
			Devam Edip Etmediği</p>
		</td>
		<td>
			<table>
				<col/>
				<col/>
				<col/>
				<col/>
				<tr>
					<td>
					</td>
					<td><p>
						Devam
						Ediyor</p>
					</td>
					<td>
					</td>
					<td><p>
						Devam
						Etmiyor</p>
					</td>
				</tr>
			</table>

		</td>
	</tr>
</table>

<ol type="A" start="3">
	<li><p><b>Talep
	Konusu </b><i>(Talebinize
	uygun seçeneğin/seçeneklerin yanında bulunan kutucuğu
	işaretleyiniz)</i></p></li>
</ol>

<table>
	<col/>
	<col/>
	<col/>
	<tr>
		<td height="11"><p>
			<b>1</b></p>
		</td>
		<td><p>
			Kişisel
			verimin işlenip işlenmediğini öğrenmek istiyorum.</p>

		</td>
		<td>
		</td>
	</tr>
	<tr>
		<td height="12"><p>
			<b>2</b></p>
		</td>
		<td><p>
			Eğer
			kişisel verilerim işleniyorsa bu veri işleme faaliyetleri
			hakkında bilgi talep ediyorum.&nbsp;</p>

		</td>
		<td>
		</td>
	</tr>
	<tr>
		<td height="12"><p>
			<b>3</b></p>
		</td>
		<td><p>
			Eğer
			kişisel verilerim işleniyorsa bunların işlenme amacını
			öğrenmek istiyorum ve işlenme amacına uygun kullanılıp
			kullanmadığı hakkında bilgi talep ediyorum.&nbsp;</p>

		</td>
		<td>
		</td>
	</tr>
	<tr>
		<td height="12"><p>
			<b>4</b></p>
		</td>
		<td><p>
			Eğer
			kişisel verilerim yurtiçinde veya yurtdışında üçüncü
			kişilere aktarılıyorsa bu üçüncü kişileri bilmek
			istiyorum.</p>

		</td>
		<td>
		</td>
	</tr>
	<tr>
		<td height="12"><p>
			<b>5</b></p>
		</td>
		<td><p>
			Kişisel
			verilerimin eksik ve/veya yanlış işlendiğini düşünüyorum
			ve düzeltilmesini talep ediyorum.
			</p>
			<p>
			<i>(Eksik
			veya yanlış olduğunu düşündüğünüz, düzeltilmesini
			istediğiniz kişisel verinize ilişkin açıklayıcı bilgileri
			D. kısmında ve kişisel verilerinizin eksiksiz ve doğru
			işlenebilmesi için gerekli bilgi ve belgeleri formun ekinde
			sununuz.)</i></p>

		</td>
		<td>
		</td>
	</tr>
	<tr>
		<td height="12"><p>
			<b>6</b></p>
		</td>
		<td><p>
			Eksik
			ve/veya yanlış işlendiğini düşündüğüm kişisel verilerim
			hakkındaki talebimin, verilerimin aktarıldığı üçüncü
			kişilere de bildirilmesini talep ediyorum.

			</p>

		</td>
		<td>
		</td>
	</tr>
	<tr>
		<td><p>
			<b>7</b></p>
		</td>
		<td><p>
			Kişisel
			verilerimin Kanun ve ilgili diğer kanun hükümlerine uygun
			olarak işlenmiş olmasına rağmen, işlenmesini gerektiren
			sebeplerin ortadan kalktığını düşünüyorum ve bu çerçevede
			kişisel verilerimin; a) Silinmesini talep ediyorum. b) yok
			edilmesini talep ediyorum.
			</p>
			<p>
			<i>(Seçiminizi
			yandaki kutucukta a veya b olarak belirtiniz, bu talebinize
			ilişkin açıklayıcı bilgileri D. kısmında ve ilgili
			belgeleri formun ekinde sununuz.)</i></p>

		</td>
		<td>
		</td>
	</tr>
	<tr>
		<td><p>
			<b>8</b></p>
		</td>
		<td><p>
			İşlenmesini
			gerektiren sebeplerin ortadan kalktığını düşündüğüm
			kişisel verilerim hakkındaki talebimin, verilerimin aktarıldığı
			üçüncü kişilere de bildirilmesini talep ediyorum.</p>

		</td>
		<td>
		</td>
	</tr>
	<tr>
		<td><p>
			<b>9</b></p>
		</td>
		<td><p>
			Kişisel
			verilerimin münhasıran otomatik sistemler vasıtasıyla analiz
			edildiğini ve bu analiz neticesinde şahsım aleyhine bir sonuç
			doğduğunu düşünüyorum. Bu sonuca itiraz ediyorum.
			</p>
			<p>
			<i>(Aleyhinize
			olduğunu düşündüğünüz analiz sonucuna ilişkin </i><i>açıklayıcı
			bilgileri D. kısmında ve ilgili belgeleri formun ekinde
			sununuz.)</i></p>

		</td>
		<td>
		</td>
	</tr>
	<tr>
		<td height="23"><p>
			<b>10</b></p>
		</td>
		<td><p>
			Kişisel
			verilerimin Kanun’a aykırı işlenmesi nedeniyle zarara
			uğradığımı düşünüyorum ve bu zararımın tazmini talep
			ediyorum.
			</p>
			<p>
			<i>(Zarara
			uğradığınızı düşündüğünüz işleme ilişkin açıklayıcı
			bilgileri D. kısmında ve zararınızı ispatlayıcı veya
			destekleyici belgeleri </i><i>formun
			ekinde sununuz.)</i></p>

		</td>
		<td>
		</td>
	</tr>
</table>

<ol type="A" start="4">
	<li><p><b>Talep
	Hakkında Açıklayıcı Bilgiler ve Ekler</b></p></li>
</ol>

<p>
Talebiniz
hakkında iletmek istediğiniz açıklayıcı bilgileri bu kısımda
belirtiniz ve var ise ekte sunduğunuz belgeleri yazınız.
</p>

<ol type="A" start="5">
	<li><p><b>Yanıtın
	Başvuru Sahibine Bildirilme Yöntemi</b></p></li>
</ol>

<p>
Talebinize
ilişkin yanıtın tarafınıza bildirilmesini istediğiniz yöntemi
ve adresi belirtiniz.
</p>

<ul>
	<li><p>Yukarıda
	belirttiğim adresime gönderilmesini istiyorum.
	</p></li>
	<li><p>Yukarıda
	belirttiğim e-posta adresime gönderilmesini istiyorum.
	</p></li>
	<li><p>Elden
	teslim almak istiyorum</p></li>
</ul>
<p>
<i>(Elden
teslimde başvuru sahibince bizzat veya noter onaylı vekaletname ile
yetkili kılınmış kişi tarafından gelinmesi gerekmektedir.) </i>
</p>

<p>
<b>F: Başvuru
Sahibinin Beyanı </b>
</p>

<p>
Bu
formda belirtmiş olduğum bilgilerin ve sunduğum belgelerin şahsıma
ait olduğunu, doğru ve güncel olduğunu; başvurumun
sonuçlandırılabilmesi için bilgi veya belge talep edilmesi
halinde bu bilgi ve belgeleri temin edeceğimi; başvurumun ek
maliyet gerektirmesi durumunda Kurul tarafından belirlenen ücreti
ödemem gerekebileceği hususunda bilgim olduğunu beyan ve taahhüt
ederim.
</p>

<p>
Başvurumun
Kanun’un 13. maddesi uyarınca değerlendirilerek tarafıma bilgi
verilmesini rica ederim.</p>

<p>
<b>İsim
Soyisim</b></p>
<p>
<b>Tarih</b></p>
<p>
<b>İmza</b></p>

<div id="sdfootnote1"><p>
	<a name="sdfootnote1sym" href="#sdfootnote1anc">1</a>
	İlgili kişinin hakları: MADDE  11- (1) Herkes, veri sorumlusuna
	başvurarak kendisiyle ilgili; a) Kişisel veri işlenip
	işlenmediğini öğrenme, b) Kişisel verileri işlenmişse buna
	ilişkin bilgi talep etme, c) Kişisel verilerin işlenme amacını
	ve bunların amacına uygun kullanılıp kullanılmadığını
	öğrenme, ç) Yurt içinde veya yurt dışında kişisel verilerin
	aktarıldığı üçüncü kişileri bilme, d) Kişisel verilerin
	eksik veya yanlış işlenmiş olması hâlinde bunların
	düzeltilmesini isteme, e) 7 nci maddede öngörülen şartlar
	çerçevesinde kişisel verilerin silinmesini veya yok edilmesini
	isteme, f) (d) ve (e) bentleri uyarınca yapılan işlemlerin,
	kişisel verilerin aktarıldığı üçüncü kişilere
	bildirilmesini isteme, g) İşlenen verilerin münhasıran otomatik
	sistemler vasıtasıyla analiz edilmesi suretiyle kişinin kendisi
	aleyhine bir sonucun ortaya çıkmasına itiraz etme, ğ) Kişisel
	verilerin kanuna aykırı olarak işlenmesi sebebiyle zarara
	uğraması hâlinde zararın giderilmesini talep etme, haklarına
	sahiptir. Veri güvenliğine ilişkin yükümlülükler</p>
</div>
<div id="sdfootnote2"><p>
	<a name="sdfootnote2sym" href="#sdfootnote2anc">2</a>
	Başvuru, Şikâyet ve Veri Sorumluları Sicili Veri sorumlusuna
	başvuru MADDE 13- (1) İlgili kişi, bu Kanunun uygulanmasıyla
	ilgili taleplerini yazılı olarak veya Kurulun belirleyeceği diğer
	yöntemlerle veri sorumlusuna iletir. (2) Veri sorumlusu başvuruda
	yer alan talepleri, talebin niteliğine göre en kısa sürede ve en
	geç otuz gün içinde ücretsiz olarak sonuçlandırır. Ancak,
	işlemin ayrıca bir maliyeti gerektirmesi hâlinde, Kurulca
	belirlenen tarifedeki ücret alınabilir. (3) Veri sorumlusu talebi
	kabul eder. veya gerekçesini açıklayarak reddeder ve cevabını
	ilgili kişiye yazılı olarak veya elektronik ortamda bildirir.
	Başvuruda yer alan talebin kabul edilmesi hâlinde veri
	sorumlusunca gereği yerine getirilir. Başvurunun veri sorumlusunun
	hatasından kaynaklanması hâlinde alınan ücret ilgiliye iade
	edilir.
	</p>

</div>
<div id="sdfootnote3"><p>
	<a name="sdfootnote3sym" href="#sdfootnote3anc">3</a>
	Kanunun kurula şikayet sürecini ihtiva eden 14. Maddesinde;  (1)
	Başvurunun reddedilmesi, verilen cevabın yetersiz bulunması veya
	süresinde başvuruya cevap verilmemesi hâllerinde; ilgili kişi,
	veri sorumlusunun cevabını öğrendiği tarihten itibaren otuz ve
	her hâlde başvuru tarihinden itibaren altmış gün içinde Kurula
	şikâyette bulunabilir.  (2) 13 üncü madde uyarınca başvuru
	yolu tüketilmeden şikâyet yoluna başvurulamaz. (3) Kişilik
	hakları ihlal edilenlerin, genel hükümlere göre tazminat hakkı
	saklıdır.
	</p>
</div>
<div id="sdfootnote4"><p>
	<a name="sdfootnote4sym" href="#sdfootnote4anc">4</a>
	Şikâyet üzerine veya resen incelemenin usul ve esasları MADDE
	15- (1) Kurul, şikâyet üzerine veya ihlal iddiasını öğrenmesi
	durumunda resen, görev alanına giren konularda gerekli incelemeyi
	yapar. (2) 1/11/1984 tarihli ve 3071 sayılı Dilekçe Hakkının
	Kullanılmasına Dair Kanunun 6 ncı maddesinde belirtilen şartları
	taşımayan ihbar veya şikâyetler incelemeye alınmaz. (3) Devlet
	sırrı niteliğindeki bilgi ve belgeler hariç; veri sorumlusu,
	Kurulun, inceleme konusuyla ilgili istemiş olduğu bilgi ve
	belgeleri on beş gün içinde göndermek ve gerektiğinde yerinde
	inceleme yapılmasına imkân sağlamak zorundadır. (4) Şikâyet
	üzerine Kurul, talebi inceleyerek ilgililere bir cevap verir.
	Şikâyet tarihinden itibaren altmış gün içinde cevap verilmezse
	talep reddedilmiş sayılır. (5) Şikâyet üzerine veya resen
	yapılan inceleme sonucunda, ihlalin varlığının anlaşılması
	hâlinde Kurul, tespit ettiği hukuka aykırılıkların veri
	sorumlusu tarafından giderilmesine karar vererek ilgililere tebliğ
	eder. Bu karar, tebliğden itibaren gecikmeksizin ve en geç otuz
	gün içinde yerine getirilir. (6) Şikâyet üzerine veya resen
	yapılan inceleme sonucunda, ihlalin yaygın olduğunun tespit
	edilmesi hâlinde Kurul, bu konuda ilke kararı alır ve bu kararı
	yayımlar. Kurul, ilke kararı almadan önce ihtiyaç duyması
	hâlinde, ilgili kurum ve kuruluşların görüşlerini de alabilir.
	(7) Kurul, telafisi güç veya imkânsız zararların doğması ve
	açıkça hukuka aykırılık olması hâlinde, veri işlenmesinin
	veya verinin yurt dışına aktarılmasının durdurulmasına karar
	verebilir.</p>

</div>
`,
})

export default WORD_DOCUMENT_CONTENT
